import React from "react";

export const TimelineIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 9.5C2 9.77614 2.22386 10 2.5 10H9.5C9.77614 10 10 9.77614 10 9.5V2.5C10 2.22386 9.77614 2 9.5 2H2.5C2.22386 2 2 2.22386 2 2.5L2 9.5ZM2.5 11C1.67157 11 1 10.3284 1 9.5L1 2.5C1 1.67157 1.67157 1 2.5 1H9.5C10.3284 1 11 1.67157 11 2.5V9.5C11 10.3284 10.3284 11 9.5 11H2.5Z"
        fill="#8A8F98"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 9C3.22386 9 3 8.77614 3 8.5V7C3 6.72386 3.22386 6.5 3.5 6.5H8C8.27614 6.5 8.5 6.72386 8.5 7V8.5C8.5 8.77614 8.27614 9 8 9H3.5ZM4 8H7.5V7.5H4V8Z"
        fill="#8A8F98"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 5.5C3.22386 5.5 3 5.27614 3 5V3.5C3 3.22386 3.22386 3 3.5 3H6C6.27614 3 6.5 3.22386 6.5 3.5V5C6.5 5.27614 6.27614 5.5 6 5.5H3.5ZM4 4.5H5.5V4H4V4.5Z"
        fill="#8A8F98"
      />
    </svg>
  );
};

export const StackIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 5.67508C10.4942 5.58211 10.4626 5.49259 10.4088 5.41662C10.3549 5.34064 10.2808 5.28123 10.195 5.24508L9.11997 4.78508L10.25 4.13508C10.3301 4.089 10.3959 4.02162 10.44 3.94042C10.4841 3.85922 10.5049 3.76737 10.5 3.67508C10.4942 3.58211 10.4626 3.49259 10.4088 3.41662C10.3549 3.34064 10.2808 3.28123 10.195 3.24508L6.19497 1.54008C6.13328 1.51395 6.06697 1.50049 5.99997 1.50049C5.93298 1.50049 5.86667 1.51395 5.80497 1.54008L1.80497 3.24508C1.71913 3.28123 1.64509 3.34064 1.5912 3.41662C1.53731 3.49259 1.50571 3.58211 1.49997 3.67508C1.49506 3.76737 1.51582 3.85922 1.55996 3.94042C1.60409 4.02162 1.66986 4.089 1.74997 4.13508L2.87997 4.78508L1.80497 5.24508C1.71913 5.28123 1.64509 5.34064 1.5912 5.41662C1.53731 5.49259 1.50571 5.58211 1.49997 5.67508C1.49506 5.76737 1.51582 5.85922 1.55996 5.94042C1.60409 6.02162 1.66986 6.089 1.74997 6.13508L2.87997 6.78508L1.80497 7.24508C1.71913 7.28123 1.64509 7.34064 1.5912 7.41662C1.53731 7.49259 1.50571 7.58211 1.49997 7.67508C1.49506 7.76737 1.51582 7.85922 1.55996 7.94042C1.60409 8.02162 1.66986 8.089 1.74997 8.13508L5.74997 10.4351C5.82598 10.479 5.91221 10.5021 5.99997 10.5021C6.08774 10.5021 6.17396 10.479 6.24997 10.4351L10.25 8.13508C10.3301 8.089 10.3959 8.02162 10.44 7.94042C10.4841 7.85922 10.5049 7.76737 10.5 7.67508C10.4942 7.58211 10.4626 7.49259 10.4088 7.41662C10.3549 7.34064 10.2808 7.28123 10.195 7.24508L9.11997 6.78508L10.25 6.13508C10.3301 6.089 10.3959 6.02162 10.44 5.94042C10.4841 5.85922 10.5049 5.76737 10.5 5.67508ZM5.99997 2.54508L8.87997 3.77008L5.99997 5.42508L3.11997 3.77008L5.99997 2.54508ZM5.74997 6.43508C5.82598 6.47897 5.91221 6.50207 5.99997 6.50207C6.08774 6.50207 6.17396 6.47897 6.24997 6.43508L8.03497 5.43508L8.87997 5.79508L5.99997 7.42508L3.11997 5.77008L3.96497 5.41008L5.74997 6.43508ZM8.87997 7.77008L5.99997 9.42508L3.11997 7.77008L3.96497 7.41008L5.74997 8.43508C5.82598 8.47897 5.91221 8.50207 5.99997 8.50207C6.08774 8.50207 6.17396 8.47897 6.24997 8.43508L8.03497 7.41008L8.87997 7.77008Z"
        fill="#8A8F98"
      />
    </svg>
  );
};

export const PrevIcon = () => {
  return (
    <svg
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.5 0C0.632608 0 0.759785 0.0526785 0.853553 0.146447C0.947321 0.240215 1 0.367392 1 0.5V4.76344L8.27406 0.409688C8.44207 0.307488 8.63445 0.252295 8.83109 0.249876C9.02772 0.247457 9.2214 0.297902 9.39188 0.395937C9.76688 0.608437 10 1.02094 10 1.46875V10.5312C10 10.9803 9.76688 11.3916 9.39188 11.6041C9.22136 11.702 9.02768 11.7524 8.83105 11.7499C8.63441 11.7474 8.44206 11.6922 8.27406 11.59L1 7.23656V11.5C1 11.6326 0.947321 11.7598 0.853553 11.8536C0.759785 11.9473 0.632608 12 0.5 12C0.367392 12 0.240215 11.9473 0.146447 11.8536C0.0526785 11.7598 0 11.6326 0 11.5V0.5C0 0.367392 0.0526785 0.240215 0.146447 0.146447C0.240215 0.0526785 0.367392 0 0.5 0Z"
        fill="#8A8F98"
      />
    </svg>
  );
};

export const PlayIcon = () => {
  return (
    <svg
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.15695 11.7499C0.965085 11.7496 0.776614 11.6993 0.610078 11.604C0.235078 11.3915 0.00195312 10.979 0.00195312 10.5312V1.46868C0.00195312 1.01962 0.235078 0.608371 0.610078 0.395871C0.780579 0.297882 0.974271 0.247491 1.17091 0.249965C1.36755 0.252439 1.55991 0.307686 1.72789 0.409933L9.4732 5.04618C9.63462 5.1474 9.76769 5.28795 9.85993 5.45466C9.95217 5.62137 10.0006 5.80878 10.0006 5.99931C10.0006 6.18984 9.95217 6.37724 9.85993 6.54395C9.76769 6.71066 9.63462 6.85122 9.4732 6.95243L1.72664 11.5899C1.55473 11.6939 1.35783 11.7492 1.15695 11.7499Z"
        fill="#8A8F98"
      />
    </svg>
  );
};
export const NextIcon = () => {
  return (
    <svg
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 0C9.36739 0 9.24021 0.0526785 9.14645 0.146447C9.05268 0.240215 9 0.367392 9 0.5V4.76344L1.72594 0.409688C1.55793 0.307488 1.36555 0.252295 1.16891 0.249876C0.972275 0.247457 0.778598 0.297902 0.608125 0.395937C0.233125 0.608437 0 1.01969 0 1.46875V10.5312C0 10.9803 0.233125 11.3916 0.608125 11.6041C0.778637 11.702 0.972324 11.7524 1.16895 11.7499C1.36559 11.7474 1.55794 11.6922 1.72594 11.59L9 7.23656V11.5C9 11.6326 9.05268 11.7598 9.14645 11.8536C9.24021 11.9473 9.36739 12 9.5 12C9.63261 12 9.75979 11.9473 9.85355 11.8536C9.94732 11.7598 10 11.6326 10 11.5V0.5C10 0.367392 9.94732 0.240215 9.85355 0.146447C9.75979 0.0526785 9.63261 0 9.5 0Z"
        fill="#8A8F98"
      />
    </svg>
  );
};

export const GoalsIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_373_7059)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 1C4.34315 1 3 2.34315 3 4C3 5.65685 4.34315 7 6 7C7.65685 7 9 5.65685 9 4C9 2.34315 7.65685 1 6 1ZM2 4C2 1.79086 3.79086 0 6 0C8.20914 0 10 1.79086 10 4C10 6.20914 8.20914 8 6 8C3.79086 8 2 6.20914 2 4Z"
          fill="#8A8F98"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.82925 6.44434C8.10299 6.40802 8.35435 6.60049 8.39067 6.87424L8.99567 11.4342C9.02092 11.6246 8.93497 11.8125 8.7745 11.9179C8.61403 12.0233 8.40739 12.0275 8.24276 11.9287L6.00001 10.5831L3.75726 11.9287C3.59262 12.0275 3.38596 12.0233 3.22549 11.9179C3.06502 11.8125 2.97909 11.6245 3.00436 11.4342L3.60936 6.87917C3.64572 6.60543 3.89711 6.41299 4.17084 6.44935C4.44458 6.48571 4.63702 6.73709 4.60066 7.01083L4.13223 10.5376L5.74276 9.57125C5.90111 9.47625 6.09892 9.47625 6.25726 9.57125L7.86795 10.5377L7.39936 7.00576C7.36304 6.73202 7.55551 6.48066 7.82925 6.44434Z"
          fill="#8A8F98"
        />
      </g>
      <defs>
        <clipPath id="clip0_373_7059">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ForwardIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.1519 11.1451L14.2986 5.84819C14.0795 5.71492 13.8288 5.64292 13.5724 5.6397C13.316 5.63649 13.0635 5.70218 12.8412 5.82991C12.6 5.97036 12.4003 6.17215 12.2623 6.41477C12.1243 6.65739 12.053 6.93221 12.0556 7.21131V10.9168L3.58435 5.84678C3.36533 5.71351 3.11454 5.64151 2.85818 5.6383C2.60182 5.63508 2.3493 5.70077 2.12701 5.8285C1.88581 5.96895 1.68607 6.17074 1.54809 6.41336C1.41011 6.65598 1.33879 6.9308 1.34138 7.20991V17.5693C1.33871 17.8485 1.40998 18.1234 1.54797 18.3661C1.68596 18.6088 1.88574 18.8107 2.12701 18.9512C2.3493 19.0789 2.60182 19.1446 2.85818 19.1414C3.11454 19.1381 3.36533 19.0661 3.58435 18.9329L12.0556 13.8605V17.5674C12.0526 17.8469 12.1237 18.1222 12.2617 18.3653C12.3997 18.6083 12.5997 18.8105 12.8412 18.9512C13.0635 19.0789 13.316 19.1446 13.5724 19.1414C13.8288 19.1381 14.0795 19.0661 14.2986 18.9329L23.1519 13.636C23.3623 13.5042 23.5358 13.321 23.6561 13.1037C23.7764 12.8864 23.8395 12.6422 23.8395 12.3938C23.8395 12.1455 23.7764 11.9012 23.6561 11.6839C23.5358 11.4666 23.3623 11.2835 23.1519 11.1516V11.1451Z"
        fill="#8A8F98"
      />
    </svg>
  );
};

export const BackwardIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.02884 11.1451L10.8821 5.84819C11.1011 5.71492 11.3519 5.64292 11.6083 5.6397C11.8647 5.63649 12.1172 5.70218 12.3395 5.82991C12.5807 5.97036 12.7804 6.17215 12.9184 6.41477C13.0564 6.65739 13.1277 6.93221 13.1251 7.21131V10.9168L21.5963 5.84678C21.8154 5.71351 22.0662 5.64151 22.3225 5.6383C22.5789 5.63508 22.8314 5.70077 23.0537 5.8285C23.2949 5.96895 23.4946 6.17074 23.6326 6.41336C23.7706 6.65598 23.8419 6.9308 23.8393 7.20991V17.5693C23.842 17.8485 23.7708 18.1234 23.6328 18.3661C23.4948 18.6088 23.295 18.8107 23.0537 18.9512C22.8314 19.0789 22.5789 19.1446 22.3225 19.1414C22.0662 19.1381 21.8154 19.0661 21.5963 18.9329L13.1251 13.8605V17.5674C13.1281 17.8469 13.057 18.1222 12.919 18.3653C12.781 18.6084 12.581 18.8105 12.3395 18.9512C12.1172 19.0789 11.8647 19.1446 11.6083 19.1414C11.3519 19.1381 11.1011 19.0661 10.8821 18.9329L2.02884 13.636C1.81837 13.5042 1.64485 13.321 1.52457 13.1037C1.40429 12.8864 1.34119 12.6422 1.34119 12.3938C1.34119 12.1455 1.40429 11.9012 1.52457 11.6839C1.64485 11.4666 1.81837 11.2835 2.02884 11.1516V11.1451Z"
        fill="#8A8F98"
      />
    </svg>
  );
};

export const MenuIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="2" width="4" height="4" rx="2" fill="#1B1C1E" />
      <rect x="2" y="10" width="4" height="4" rx="2" fill="#1B1C1E" />
      <rect x="10" y="10" width="4" height="4" rx="2" fill="#1B1C1E" />
      <rect x="10" y="2" width="4" height="4" rx="2" fill="#1B1C1E" />
    </svg>
  );
};
